module.exports = __webpack_public_path__ + "img/directory.cec579a.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/img/directory.jpg
// module id = ./assets/img/directory.jpg
// module chunks = 28